import { useState } from "react";
import { useAuth } from "../../store/AuthContext/AuthContext";
import ApiManager from "../../api/ApiManager";
import OnboardingLayout from "../../layouts/OnboardingLayout/OnboardingLayout";
import { Mail } from "lucide-react";
import { GoogleIcon } from "../../Icons/GoogleIcon";
import Button from "../../components/Button/Button";
import { Link } from "react-router-dom";
import Typography from "../../components/Typography/Typography";

const Login = () => {
  const CLIENT_ID = "bo24stke7qeq3l76saqttte3j";
  const REDIRECT_URI = "https://getathena.app/client/library";
  const AUTH_URL = `https://eu-west-3cee3sfvyn.auth.eu-west-3.amazoncognito.com/oauth2/authorize?identity_provider=Google&redirect_uri=${REDIRECT_URI}&response_type=CODE&client_id=${CLIENT_ID}&scope=openid+profile+email`;

  const { login, isAuthenticated } = useAuth();
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const api = new ApiManager();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const response = await api.post("/login", credentials);
      if (response.data) {
        login(response.data); // Send user data to AuthContext
      }
    } catch (err) {
      setError("Invalid credentials. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (isAuthenticated) {
    window.location.href = "/client/library";
  }

  return (
    <div className="overflow-hidden ">
      <OnboardingLayout hasProgress={false} >
        <div className="pt-12 pb-14 md:mx-auto md:w-[40rem] w-auto px-4 flex flex-col gap-5 md:gap-6">
          <Typography
            align="center"
            family="serif"
            size="32"
            desktopSize="48"
            weight="sb"
            color="black"
          >
            Accedi al tuo account
          </Typography>
          <div className="flex flex-col gap-4 w-full">
            <Link to="/login-form">
              <Button
                text="Accedi con Email"
                width="full"
                size={window.innerWidth >= 768 ? "lg" : "md"}
                licon={<Mail size={24} />}
              />
            </Link>

            <div className="flex items-center gap-3">
              <div className="w-1/2 border border-gray-200" />
              <Typography size="16" weight="md" color="gray-600">
                oppure
              </Typography>
              <div className="w-1/2 border border-gray-200" />
            </div>

            <a href={AUTH_URL} className="block w-full">
              <Button
                text="Accedi con Google"
                width="full"
                type="bw"
                size={window.innerWidth >= 768 ? "lg" : "md"}
                licon={<GoogleIcon size={24} />}
              />
            </a>
          </div>
        </div>

        <div className="absolute bottom-0 md:-bottom-16 left-1/2 -translate-x-1/2 md:w-[25rem] w-[20rem] md:h-[25rem] h-[20rem]  pointer-events-none">
          <img
            src="assets/images/illustrations/celebrating.png"
            alt="Illustrazione di persone che festeggiano"
            className="object-contain"
          />
        </div>
      </OnboardingLayout>
    </div>
  );
};

export default Login;
